import { DocsOwnershipApi } from '@appfolio/backstage-plugin-docs-ownership-common';
import { TechDocsMetadataApi } from '@appfolio/backstage-plugin-techdocs-common';
import { createApiRef } from '@backstage/core-plugin-api';

export const docsOwnershipApiRef = createApiRef<DocsOwnershipApi>({
  id: 'plugin.docs-ownership.service',
});

export const techDocsMetadataApiRef = createApiRef<TechDocsMetadataApi>({
  id: 'plugin.techdocs-metadata.service',
});
